export default __webpack_public_path__ + "static/media/chrome.191aefd5.svg";